var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("validation-provider", {
        attrs: { name: "Inventories", rules: "checks" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function({ errors }) {
              return [
                _c("inventories", {
                  attrs: { "is-read-only": _vm.isReadOnly },
                  model: {
                    value: _vm.model.inventories,
                    callback: function($$v) {
                      _vm.$set(_vm.model, "inventories", $$v)
                    },
                    expression: "model.inventories"
                  }
                }),
                errors[0]
                  ? _c("error", {
                      attrs: {
                        message: "Seleccione al menos un inventario",
                        variant: "no-border"
                      }
                    })
                  : _vm._e()
              ]
            }
          }
        ])
      }),
      _vm.hasRiasecInventories
        ? _c(
            "div",
            { staticClass: "mt-3" },
            [
              _c("section-title", {
                attrs: {
                  content:
                    "Las tres áreas principales identificadas por el evaluado son las siguientes:",
                  "has-line": ""
                }
              }),
              _vm._l(_vm.areasByEvaluatedMainTasks, function(item) {
                return _c(
                  "div",
                  { key: item.area.id },
                  [
                    _c("answer", {
                      attrs: { "is-read-only": _vm.isReadOnly, value: item },
                      on: {
                        input: function($event) {
                          return _vm.onAnswer(item, $event)
                        }
                      }
                    })
                  ],
                  1
                )
              })
            ],
            2
          )
        : _vm._e(),
      _vm.hasCirinoArciInventory
        ? _c(
            "div",
            [
              _c("section-title", {
                attrs: { content: "Inventario Cirino y ARCI:", "has-line": "" }
              }),
              _vm._m(0),
              _c(
                "div",
                { staticClass: "pt-2" },
                _vm._l(_vm.areasByCirinoArciInventory, function(item) {
                  return _c(
                    "div",
                    { key: item.area.id },
                    [
                      _c("answer", {
                        attrs: { "is-read-only": _vm.isReadOnly, value: item },
                        on: {
                          input: function($event) {
                            return _vm.onAnswer(item, $event)
                          }
                        }
                      })
                    ],
                    1
                  )
                }),
                0
              )
            ],
            1
          )
        : _vm._e(),
      _vm.hasReadingFree
        ? _c(
            "div",
            { staticClass: "mt-3" },
            [
              _c("section-title", {
                attrs: {
                  content:
                    "Resultados de acuerdo con los grupos de carreras o “clusters” definidas por el Departamento del Trabajo de EUA y categorías de interés.:",
                  "has-line": ""
                }
              }),
              _c("section-title", {
                attrs: {
                  "container-class": "tag-badge-main-info mt-4 mb-4",
                  content: "Grupo de Carrera o “cluster”",
                  icon: "fas fa-user-tie"
                }
              }),
              _c("clusters", {
                attrs: {
                  aggregable: "",
                  "is-alternative": "",
                  "is-read-only": _vm.isReadOnly,
                  max: _vm.maxAlternativeGoals
                },
                on: {
                  add: _vm.addAlternativeGoal,
                  remove: function($event) {
                    return _vm.removeAlternativeGoal($event)
                  }
                },
                model: {
                  value: _vm.model.alternativeGoals,
                  callback: function($$v) {
                    _vm.$set(_vm.model, "alternativeGoals", $$v)
                  },
                  expression: "model.alternativeGoals"
                }
              }),
              _c(
                "div",
                { staticClass: "my-3" },
                [
                  _c("section-title", {
                    attrs: {
                      "container-class": "tag-badge-main-info mt-4 mb-4",
                      content: "Categorías de interés: Personas/ Datos/ Cosas",
                      icon: "fas fa-user-tie"
                    }
                  }),
                  _c("clusters", {
                    attrs: {
                      "is-alternative": false,
                      "is-read-only": _vm.isReadOnly
                    },
                    model: {
                      value: _vm.categoriesOfInteres,
                      callback: function($$v) {
                        _vm.categoriesOfInteres = $$v
                      },
                      expression: "categoriesOfInteres"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "mx-1" }, [
      _c("p", [
        _vm._v(
          " Son herramientas para identificar intereses vocacionales en estudiantes y adultos desde tercer grado en adelante. Sus escalas permiten evaluar intereses comunes en cada nivel escolar, fomentando el desarrollo de identidad y autoconcepto, así como la aceptación de gustos individuales. Además, ayudan a descubrir intereses vinculados a áreas STEM como ciencias y matemáticas. "
        )
      ]),
      _c("p", [
        _vm._v(
          " La tipología que emplean estos inventarios clasifica los intereses en áreas que reflejan motivaciones específicas derivadas de necesidades generales como logro, autonomía, afiliación, seguridad, empoderamiento y estimulación. Los intereses pueden ser manuales, sociales, comerciales o científicos, y se agrupan en categorías como: "
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }